import React, {useCallback} from "react"
import {Button, Result} from "antd"
import {useNavigate} from "react-router-dom"

const ErrorBadGateway = () => {
    const navigate = useNavigate()
    const onClickHandler = useCallback(() => navigate("/"), [])

    return (
        <Result
            status="500"
            title="500"
            subTitle="Неизвестная ошибка"
            extra={
                <Button type="primary" onClick={onClickHandler}>
                    Назад на главную
                </Button>
            }
        />
    )
}

export default ErrorBadGateway
